import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBars, faBookmark as faBookmarkSolid, faCaretDown, faCaretUp, faCheck, faChevronCircleDown, faChevronCircleUp, faChevronDown, faChevronRight, faChevronUp, faDollarSign, faEllipsisH, faFileInvoice, faFilter, faLevelUpAlt, faMinus, faPlus, faShoppingCart, faSpinner, faTh, faThList, faUndo, faUser } from '@fortawesome/free-solid-svg-icons';
import { faBookmark, faCheckCircle, faCheckSquare, faCircle, faMinusSquare, faQuestionCircle, faSquare } from '@fortawesome/free-regular-svg-icons';

import { CommonModule } from '@angular/common';
import { CourseAuthorListComponent } from 'src/app/course-author-list/course-author-list.component';
import { CourseTagBarComponent } from 'src/app/course-tag-bar/course-tag-bar.component';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [
    CourseTagBarComponent,
    CourseAuthorListComponent
  ],
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
  exports: [
    CourseTagBarComponent,
    CourseAuthorListComponent
  ]
})
export class SharedModule { 
  constructor(library: FaIconLibrary) {
    library.addIcons(faMinus, faDollarSign, faShoppingCart, faSquare, faCheckSquare, faMinusSquare, faCircle, faCheckCircle, faCheck, faChevronCircleDown, faChevronCircleUp, faTh, faThList, faBookmark, faBookmarkSolid, faFileInvoice, faUser, faBars, faFilter, faCaretDown, faCaretUp, faUndo, faSpinner, faChevronRight, faChevronUp, faChevronDown, faCheck, faPlus, faQuestionCircle, faLevelUpAlt, faEllipsisH);
  }
}
